module.exports = "/images/oculus-16.jpg";